// Adjust the path if needed
import SEO from "./SeoHelmet";
import metaConfig from "./SeoComponent";
import { useLocation } from "react-router-dom";

import React from "react";
import Slider from "react-slick";
import "./HomePage.css";
import axios from "axios";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import "slick-carousel/slick/slick.css";
import Header from "./Header";
import Footer from "./Footer";
import CONFIG from "../src/config";
import BackgroundMagicSlider from "./Magic_sliderMainbanner";
import EvntFullslider from "./EventCarousel";

function Mainpage() {
  const location = useLocation(); // Get the current location (path)

  const meta = metaConfig.home;

  const toggleSubmenu = (e) => {
    e.preventDefault();
    setSubmenuOpen((prevState) => !prevState);
  };

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    service: "",
    business: "",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  /////Api trggered part
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setAlertMessage("Subject Submitted Successfully!");
    setShowAlert(true);
    setTimeout(() => {
      setShowAlert(false);
    }, 3000);

    const payload = {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      subject: formData.subject,
      service: formData.service,
      business: formData.business,
    };
    /////Api trggered part

    console.log("Payload:", payload);

    try {
      const response = await fetch(`${CONFIG.BASE_URL}/api/form/submit`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        const data = await response.json();
        console.log("Success:", data);
      } else {
        console.error("Error:", response.statusText);
      }
    } catch (error) {
      console.error("Network error:", error);
    }
  };
  /////Post API In contact Form

  ///// Blog News Get Api
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    // Fetch data from the backend
    axios
      .get(`${CONFIG.BASE_URL}/api/blogimages/images`) // Replace with your API URL
      .then((response) => {
        setBlogs(response.data); // Assuming response.data is an array of blog objects
      })
      .catch((error) => {
        console.error("Error fetching blog data:", error);
      });
  }, []);

  const [activeIndexs, setActiveIndexs] = useState(0); // State to track active dot
  const [activeIndex, setActiveIndex] = useState(0); // State to track active dot

  ///// Event Name Get Api
  const [sliderData, setSliderData] = useState([]);

  const CustomPrevArrow = ({ onClick }) => {
    return (
      <button
        className="slick-prev custom-arrow"
        onClick={onClick}
        style={{
          position: "absolute",
          left: "-50px", // For desktop
          top: "50%",
          zIndex: 2,
          color: "blue",
          background: "none",
          border: "none",
          fontSize: "30px", // Arrow size
          cursor: "pointer",
          transform: "translateY(-50%)",
          width: "40px", // Constrain width
          height: "40px",
          lineHeight: "40px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "0",
          margin: "0",
          overflow: "hidden",
          // Mobile responsive styles
          ...(window.innerWidth <= 991 && {
            left: "-15px",
            fontSize: "25px",
            width: "30px",
            height: "30px",
          }),
        }}
      >
        &#10094; {/* Left Arrow */}
      </button>
    );
  };

  const CustomNextArrow = ({ onClick }) => {
    return (
      <button
        className="slick-next custom-arrow"
        onClick={onClick}
        style={{
          position: "absolute",
          right: "-50px", // For desktop
          top: "50%",
          zIndex: 2,
          color: "blue",
          background: "none",
          border: "none",
          fontSize: "30px", // Arrow size
          cursor: "pointer",
          transform: "translateY(-50%)",
          width: "40px", // Constrain width
          height: "40px",
          lineHeight: "40px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "0",
          margin: "0",
          overflow: "hidden",
          // Mobile responsive styles
          ...(window.innerWidth <= 991 && {
            right: "-15px",
            fontSize: "25px",
            width: "30px",
            height: "30px",
          }),
        }}
      >
        &#10095; {/* Right Arrow */}
      </button>
    );
  };

  const [formDatas, setFormDatas] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    service: "",
    business: "",
  });

  const handleChanges = (e) => {
    const { name, value } = e.target;
    setFormDatas((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const validateForm = () => {
    let tempErrors = {};
    let formIsValid = true;

    // Name validation
    if (!formDatas.name) {
      tempErrors.name = "Name is required";
      formIsValid = false;
    } else if (!/^[a-zA-Z\s]{3,}$/.test(formDatas.name.trim())) {
      tempErrors.name = "Name must be at least 3 letters";
      formIsValid = false;
    }

    if (!formDatas.phone) {
      tempErrors.phone = "Phone number is required";
      formIsValid = false;
    } else if (!/^[6789]\d{9}$/.test(formDatas.phone)) {
      tempErrors.phone = "Contact must be 10 digits (start with 6, 7, 8, or 9)";
      formIsValid = false;
    }

    // Subject Validation
    if (!formDatas.subject) {
      tempErrors.subject = "Subject is required";
      formIsValid = false;
    }

    // Service and Business Validation
    if (!formDatas.service || formDatas.service === "Select Our Service") {
      tempErrors.service = "Please select a service";
      formIsValid = false;
    }

    if (!formDatas.business || formDatas.business === "Group of Business") {
      tempErrors.business = "Please select a business group";
      formIsValid = false;
    }

    if (!formDatas.email) {
      tempErrors.email = "Email is required";
      formIsValid = false;
    } else {
      // General email format validation
      const generalEmailPattern = /^\S+@\S+\.\S+$/;
      // Allowed email providers (case-sensitive to prevent uppercase TLDs)
      const allowedEmailPattern =
        /^[\w.-]+@(gmail\.com|yahoo\.com|cogniitec\.com|outlook\.com|hotmail\.com|icloud\.com|protonmail\.com|aol\.com)$/;
      // Negative validation for uppercase TLDs
      const uppercaseTLDPattern = /^[\w.-]+@[a-zA-Z0-9.-]+\.[A-Z]+$/;

      if (!generalEmailPattern.test(formDatas.email)) {
        tempErrors.email = "Email is invalid";
        formIsValid = false;
      } else if (!allowedEmailPattern.test(formDatas.email)) {
        tempErrors.email =
          "Please enter valid email format (e.g., user@gmail.com)";
        formIsValid = false;
      } else if (uppercaseTLDPattern.test(formDatas.email)) {
        tempErrors.email =
          "Email TLD must be in lowercase (e.g., .com, .net, .org).";
        formIsValid = false;
      }
    }
    setErrors(tempErrors);
    return formIsValid;
  };
  const [errors, setErrors] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    service: "",
    business: "",
  });

  const handleSubmits = async (e) => {
    e.preventDefault(); // Prevent default form submission

    // Validate form before proceeding
    if (!validateForm()) {
      return; // Stop submission if validation fails
    }

    setShowAlert(true); // Show the alert
    setTimeout(() => setShowAlert(false), 3000); // Hide the alert after 3 seconds

    try {
      console.log("Submitting Data:", formDatas); // Debugging log

      const response = await axios.post(
        `${CONFIG.BASE_URL}/Contact/submitforms`,
        formDatas
      );
      console.log("Response:", response.data); // Handle response

      // Reset form fields after successful submission
      setFormDatas({
        name: "",
        email: "",
        phone: "",
        subject: "",
        service: "",
        business: "",
      });
    } catch (error) {
      console.error("Error:", error.response?.data || error.message); // Handle error
    }
  };

  const [slidesToShow, setSlidesToShow] = useState(1); // Default to 1
  const [isInfinite, setIsInfinite] = useState(true); // Default to true
  useEffect(() => {
    const totalCards = sliderData.length;

    // Update the slidesToShow and infinite mode based on the number of cards
    if (totalCards === 1) {
      setSlidesToShow(1); // If 1 card, show only 1
      setIsInfinite(false); // Disable infinite mode for single card
    } else if (totalCards === 2) {
      setSlidesToShow(2); // If 2 cards, show 2
      setIsInfinite(true); // Enable infinite mode
    } else if (totalCards > 2) {
      setSlidesToShow(3); // If more than 2 cards, show
      setIsInfinite(true); // Enable infinite mode
    }
  }, [sliderData]); // Re-run whenever the sliderData changes

  const settings = {
    infinite: isInfinite, // Use the dynamically calculated value
    speed: 500,
    slidesToShow: slidesToShow, // Use the dynamically calculated value
    slidesToScroll: 1, // Always scroll one card at a time
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    responsive: [
      {
        breakpoint: 1024, // For medium screens
        settings: {
          slidesToShow: Math.min(slidesToShow, 2), // Show up to 2 cards on medium screens
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768, // For tablets
        settings: {
          slidesToShow: Math.min(slidesToShow, 1), // Show up to 1 card on tablets
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480, // For mobile screens
        settings: {
          slidesToShow: Math.min(slidesToShow, 1), // Show up to 1 card on mobile
          slidesToScroll: 1,
        },
      },
    ],
  };

  /////blog

  const [cardsToShow, setCardsToShow] = useState(1); // Default to 1
  const [isLooping, setIsLooping] = useState(true); // Default to true
  useEffect(() => {
    const totalItems = blogs.length;

    // Update the cardsToShow and looping mode based on the number of items
    if (totalItems === 1) {
      setCardsToShow(1); // If 1 item, show only 1
      setIsLooping(false); // Disable looping mode for a single item
    } else if (totalItems === 2) {
      setCardsToShow(2); // If 2 items, show 2
      setIsLooping(true); // Enable looping mode
    } else if (totalItems > 2) {
      setCardsToShow(3); // If more than 2 items, show 3
      setIsLooping(true); // Enable looping mode
    }
  }, [blogs]); // Re-run whenever the sliderData changes

  const settingss = {
    infinite: isLooping, // Use the dynamically calculated value
    speed: 500,
    slidesToShow: cardsToShow, // Use the dynamically calculated value
    slidesToScroll: 1, // Always scroll one item at a time
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    responsive: [
      {
        breakpoint: 1024, // For medium screens
        settings: {
          slidesToShow: Math.min(cardsToShow, 2), // Show up to 2 items on medium screens
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768, // For tablets
        settings: {
          slidesToShow: Math.min(cardsToShow, 1), // Show up to 1 item on tablets
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480, // For mobile screens
        settings: {
          slidesToShow: Math.min(cardsToShow, 1), // Show up to 1 item on mobile
          slidesToScroll: 1,
        },
      },
    ],

    beforeChange: (_, next) => setActiveIndexs(next), // Update active index on slide change
    appendDots: (dots) => (
      <div
        style={{
          marginTop: "20px",
        }}
      >
        <ul
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "0",
            fontSize: "12px",
            listStyle: "none",
          }}
        >
          {dots}
        </ul>
      </div>
    ),
    customPaging: (i) => (
      <div
        style={{
          width: "24px",
          height: "24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          position: "relative",
        }}
      >
        {/* Inner Dot */}
        <div
          style={{
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            background: activeIndexs === i ? "#52788e" : "transparent", // Change color based on active index
            transition: "0.5s",
          }}
        />
        {/* Outer Circle */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            margin: "auto",
            width: "20px",
            height: "20px",
            borderRadius: "50%",
            border: activeIndexs === i ? "2px solid #52788e" : "2px solid #ccc", // Change border color
            transition: "0.5s",
          }}
        />
      </div>
    ),
  };

  useEffect(() => {
    const fetchSliderData = async () => {
      try {
        const response = await fetch(`${CONFIG.BASE_URL}/api/images/images`);
        const data = await response.json();

        const formattedData = data.map((item) => ({
          id: item._id,
          imageUrl: `${item.imagePath}`,
          title: item.title,
          description: item.description,
        }));

        setSliderData(formattedData);
      } catch (error) {
        console.error("Error fetching slider data:", error);
      }
    };

    fetchSliderData();
  }, []);

  const [submenuOpen, setSubmenuOpen] = useState(false);

  //////// Live Calendar
  const [currentDate, setCurrentDate] = useState("");

  useEffect(() => {
    const updateDate = () => {
      const date = new Date();
      const options = { day: "numeric", month: "short", year: "numeric" };
      const formattedDate = date.toLocaleDateString("en-US", options);
      setCurrentDate(formattedDate);
    };
    updateDate();
    const interval = setInterval(updateDate, 1000);

    return () => clearInterval(interval);
  }, []);

  //////// Live Calendar

  const sliderItems = [
    "Beyond <br />Finance, Beyond Education",
    "Wealth of Knowledge,<br />Future of Excellence",
    "Financial Wisdom, <br />Educational Excellence",
    "Smart Money,<br /> Brighter Futures",
  ];
  const subTextItems = [
    "Creating Leaders Who Transform Tomorrow",
    "Empowering Futures With Financial Expertise",
    "Transforming Lives Through Knowledge & Security",
    "Empowering Lives Through Financial Wisdom & Educational Innovation",
  ];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsVisible(false); // Start hiding animation

      // After the hiding animation duration, switch to the next slide
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % sliderItems.length);
        setIsVisible(true); // Start showing animation for all texts/slides at once
      }, 1000); // Duration of hiding animation (same as the time for all text to disappear)
    }, 2000); // Interval between slides

    return () => clearInterval(interval);
  }, [sliderItems.length]);

  return (
    <div className="homebannblk">
      <SEO {...meta} />

      <div className="container-fluid position-relative p-0 ">
        <div className="w-100 me-3 top_head">
          <div className="top_head align-items-center"></div>
        </div>

        <Header />

        <div
          className="homebannerwrap align-items-center justify-content-center"
          style={{ paddingTop: "11rem", position: "relative", height: "100vh" }}
        >
          {/* Background Video */}
          <div
            className="vidiobg"
            style={{
              height: "100vh",
              width: "100%",
              overflow: "hidden",
              position: "absolute",
              top: 0,
              left: 0,
              zIndex: -1,
            }}
          >
            <video
              autoPlay
              loop
              muted
              playsInline
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover", // Ensures the video scales properly
              }}
              poster=""
            >
              <source src="assets/video/pexels-2022395.mp4" type="video/mp4" />
            </video>
          </div>

          <div class="section-overlay"></div>
          <div>
            <div className="row">
              <div className="col-12 ">
                <BackgroundMagicSlider />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade "
        id="searchModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel "
        aria-hidden="true"
      >
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content rounded-0">
            <div className="col-lg-12 m-auto modal-header justify-content-lg-end">
              <button
                type="button"
                className="btn-close justify-content-lg-end textssss"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="col-lg-9 m-auto modal-header align-items-center text-center">
              <h4
                className="modal-title mb-0 m-auto text-white"
                id="exampleModalLabel"
              >
                Search by keyword
              </h4>
            </div>
            <div className="modal-body align-items-center">
              <div className="input-group w-75 mx-auto d-flex">
                <input
                  type="search"
                  className="form-control p-3"
                  placeholder="keywords"
                  aria-describedby="search-icon-1"
                />
                <span
                  id="search-icon-1"
                  className="input-group-text btn border p-3"
                >
                  <i className="fa fa-search text-white"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="overlaygradient innercontain  container-fluid feature py-5">
        <div className="container py-6 ">
          <div
            className="text-center mx-auto pb-5 wow fadeInUp"
            data-wow-delay="0.2s"
            animation-name="fadeInUp"
            style={{ maxWidth: "880px" }}
          >
            <h1 className="display-3 text-white text-capitalize mb-3">
              Kovai Tech India Group
            </h1>
            <p className="text-white">
              KTIG offers services tailored to streamline and enhance technology
              adoption for end users.
            </p>
          </div>
          <div className="row featureinner g-4 col-lg-9 m-auto ">
            <div className="col-md-2 wow fadeInUp m-auto" data-wow-delay="0.2s">
              <div className="feature-item p-4">
                <div className="feature-icon ">
                  <i className="it_icons feat_items_1 fa-3x"></i>
                </div>
                <a href="#" className="btn text-white">
                  Banking
                </a>
              </div>
            </div>
            <div className="col-md-2 wow fadeInUp m-auto" data-wow-delay="0.4s">
              <div className="feature-item p-4">
                <div className="feature-icon ">
                  <i className="it_icons feat_items_2 fa-3x"></i>
                </div>
                <a href="#" className="btn text-white">
                  Finance
                </a>
              </div>
            </div>
            <div className="col-md-2 wow fadeInUp m-auto" data-wow-delay="0.6s">
              <div className="feature-item p-4">
                <div className="feature-icon ">
                  <i className="it_icons feat_items_3 fa-3x"></i>
                </div>
                <a href="#" className="btn text-white">
                  Investment
                </a>
              </div>
            </div>
            <div className="col-md-2 wow fadeInUp m-auto" data-wow-delay="0.8s">
              <div className="feature-item p-4">
                <div className="feature-icon ">
                  <i className="it_icons feat_items_4 fa-3x"></i>
                </div>
                <a href="#" className="btn text-white">
                  IT-Sector
                </a>
              </div>
            </div>
            <div className="col-md-2 wow fadeInUp m-auto" data-wow-delay="0.8s">
              <div className="feature-item p-4">
                <div className="feature-icon ">
                  <i className="it_icons feat_items_5 fa-3x"></i>
                </div>
                <a href="#" className="btn text-white">
                  Non-IT Sector
                </a>
              </div>
            </div>
            <div className="col-md-2 wow fadeInUp m-auto" data-wow-delay="0.8s">
              <div className="feature-item p-4">
                <div className="feature-icon ">
                  <i className="it_icons feat_items_6 fa-3x"></i>
                </div>
                <a href="#" className="btn text-white">
                  Sales
                </a>
              </div>
            </div>
            <div className="col-md-2 wow fadeInUp m-auto" data-wow-delay="0.8s">
              <div className="feature-item p-4">
                <div className="feature-icon">
                  <i className="it_icons feat_items_7 fa-3x"></i>
                </div>
                <a href="#" className="btn text-white">
                  Education
                </a>
              </div>
            </div>
            <div className="col-md-2 wow fadeInUp m-auto" data-wow-delay="0.8s">
              <div className="feature-item p-4">
                <div className="feature-icon ">
                  <i className="it_icons feat_items_8 fa-3x"></i>
                </div>
                <a href="#" className="btn text-white">
                  Training
                </a>
              </div>
            </div>
            <div className="col-md-2 wow fadeInUp m-auto" data-wow-delay="0.8s">
              <div className="feature-item p-4">
                <div className="feature-icon">
                  <i className="it_icons feat_items_9 fa-3x"></i>
                </div>
                <a href="#" className="btn text-white">
                  Insurance
                </a>
              </div>
            </div>
            <div
              className="col-md-2 col-lg-6 col-xl-2 wow fadeInUp m-auto"
              data-wow-delay="0.8s"
            >
              <div className="feature-item p-4">
                <div className="feature-icon">
                  <i className="it_icons feat_items_10 fa-3x"></i>
                </div>
                <a href="#" className="btn text-white">
                  Marketing
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid about overflow-hidden py-5">
        <div class="container">
          <div class="row g-5">
            <div class="col-xl-9 m-auto">
              <div class="about-item home_about text-center">
                <h1 class="display-3 text-white mb-3">About Us</h1>
                <p
                  class="mb-4 text-white text-left"
                  style={{
                    fontFamily: "poppins",
                    color: "white",
                  }}
                >
                  Kovai Tech India Group (KTIG) is a dynamic conglomerate
                  integrating expertise across key sectors to foster innovation
                  and growth. With a strong presence in industries like
                  financial services, education, information technology, and
                  social development, KTIG is committed to creating impactful
                  solutions. Our diverse approach ensures we drive progress and
                  contribute to the well-being of communities and businesses
                  alike.
                </p>
                <p
                  class="mb-4 text-white text-left"
                  style={{
                    fontFamily: "poppins",
                    color: "white",
                  }}
                >
                  At KTIG, we believe in the power of collaboration and
                  continuous improvement to achieve sustainable development. By
                  investing in cutting-edge technologies and nurturing talent
                  across all sectors, we strive to address complex challenges
                  and unlock new growth opportunities. Our initiatives are
                  designed to bridge gaps, empower individuals, and strengthen
                  communities while maintaining a strong focus on environmental
                  and social responsibility. Through strategic partnerships and
                  a forward-thinking vision, KTIG aims to inspire change and
                  leave a lasting positive impact on society and the industries
                  we serve.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid service bg-light overflow-hidden p-0">
        <div className="clientslide wow fadeInUp">
          <div className="container-fluid p-0">
            <div className="slider">
              <div className="slide-track">
                <div className="slide">
                  <div className="slide_itemlist">
                    <img
                      src="assets/img/clients/crescent logo.png"
                      height="100"
                      width="250"
                      alt="clientlogo"
                    />
                  </div>
                </div>
                <div className="slide">
                  <div className="slide_itemlist">
                    <img
                      src="assets/img/clients/AIIRMYCART.png"
                      height="100"
                      width="250"
                      alt="clientlogo"
                    />
                  </div>
                </div>
                <div className="slide">
                  <div className="slide_itemlist">
                    <img
                      src="assets/img/clients/edilink.png"
                      height="100"
                      width="250"
                      alt="clientlogo"
                    />
                  </div>
                </div>
                <div className="slide">
                  <div className="slide_itemlist">
                    <img
                      src="assets/img/clients/DFLv3.png"
                      height="100"
                      width="250"
                      alt="clientlogo"
                    />
                  </div>
                </div>
                <div className="slide">
                  <div className="slide_itemlist">
                    <img
                      src="assets/img/clients/srbt.png"
                      height="100"
                      width="250"
                      alt="clientlogo"
                    />
                  </div>
                </div>
                <div className="slide">
                  <div className="slide_itemlist">
                    <img
                      src="assets/img/clients/logo_dark.png"
                      height="100"
                      width="250"
                      alt="clientlogo"
                    />
                  </div>
                </div>
                <div className="slide">
                  <div className="slide_itemlist">
                    <img
                      src="assets/img/clients/logoa-1.png"
                      height="100"
                      width="250"
                      alt="clientlogo"
                    />
                  </div>
                </div>
                <div className="slide">
                  <div className="slide_itemlist">
                    <img
                      src="assets/img/clients/mz account.png"
                      height="100"
                      width="250"
                      alt="clientlogo"
                    />
                  </div>
                </div>
                <div className="slide">
                  <div className="slide_itemlist">
                    <img
                      src={"assets/img/clients/Nantech - Logo.png"}
                      height="100"
                      width="250"
                      alt="clientlogo"
                    />
                  </div>
                </div>
                <div className="slide">
                  <div className="slide_itemlist">
                    <img
                      src="assets/img/clients/TK MART LOGO.png"
                      height="100"
                      width="250"
                      alt="clientlogo"
                    />
                  </div>
                </div>
                <div className="slide">
                  <div className="slide_itemlist">
                    <img
                      src="assets/img/clients/NENE LOGO PNG.png"
                      height="100"
                      width="250"
                      alt="clientlogo"
                    />
                  </div>
                </div>
                <div className="slide">
                  <div className="slide_itemlist">
                    <img
                      src="assets/img/clients/VK Logo PNG.png"
                      height="100"
                      width="250"
                      alt="clientlogo"
                    />
                  </div>
                </div>
                <div className="slide">
                  <div className="slide_itemlist">
                    <img
                      src="assets/img/clients/royal shelter.png"
                      height="100"
                      width="250"
                      alt="clientlogo"
                    />
                  </div>
                </div>
                <div className="slide">
                  <div className="slide_itemlist">
                    <img
                      src="assets/img/clients/nouveaux.png"
                      height="100"
                      width="250"
                      alt="clientlogo"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="training_sect container-fluid blog py-5">
        <div className="container ">
          <div
            className="tiledivision text-center mx-auto wow fadeInUp"
            data-wow-delay="0.2s"
            style={{ maxWidth: "800px" }}
          >
            <h1 className=" display-3 text-white text-capitalize pb-3">
              OUR TRAINING AND DIVISION
            </h1>
          </div>

          <EvntFullslider carouselItems={blogs} />
        </div>
      </div>

      {/* Testimonial Part End */}

      <div className="container-fluid contact py-5">
        <div className="container">
          <div className="row pt-5 pb-5 group_contact g-5">
            <div
              className="col-lg-10 m-auto h-100 wow fadeInUp"
              data-wow-delay="0.2s"
            >
              <form autoComplete="off" onSubmit={handleSubmits}>
                <div className="row form_inner g-4">
                  <div
                    className="text-center mt-0 mx-auto pb-2"
                    style={{ maxWidth: "800px" }}
                  >
                    <h1 className="display-3 text-white text-capitalize">
                      Get In Touch
                    </h1>
                    <p
                      className="mb-0 text-white"
                      style={{
                        width: "100%",
                        fontSize: "14px",
                        marginRight: "12rem",
                      }}
                    >
                      Contact our skilled team today or email us at to learn how
                      we can design tailored solutions for your unique
                      requirements.
                    </p>
                  </div>

                  <div className="form_left btn-md-square rounded-circle">
                    <i className="fas fa-map-marker-alt fa-2x"></i>
                  </div>
                  <div className="col-lg-12 col-xl-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control border-1"
                        name="name"
                        value={formDatas.name}
                        onChange={handleChanges}
                        onKeyDown={(e) => {
                          if (
                            !/^[a-zA-Z\s]$/.test(e.key) &&
                            e.key !== "Backspace"
                          ) {
                            e.preventDefault(); // Prevent numbers and special characters
                          }
                        }}
                        placeholder="Full Name"
                      />
                      {errors.name && (
                        <p className="text-danger">{errors.name}</p>
                      )}

                      <label>Your Name</label>
                    </div>
                  </div>
                  <div className="col-lg-12 col-xl-6">
                    <div className="form-floating">
                      <input
                        type="email"
                        className="form-control border-1"
                        name="email"
                        value={formDatas.email}
                        onChange={handleChanges}
                        placeholder="Email Address"
                      />
                      {errors.email && (
                        <p className="text-danger">{errors.email}</p>
                      )}

                      <label>Your Email</label>
                    </div>
                  </div>

                  <div className="col-lg-12 col-xl-6">
                    <div className="input-group" style={{ gap: "0px" }}>
                      {/* Country Code Dropdown */}
                      <select
                        className="countrycode form-select border-1"
                        name="countryCode"
                        style={{ maxWidth: "32%", paddingRight: "5px" }} // Adjust width & padding
                      >
                        <option value="+91">IN +91</option>
                        <option value="+1">US +1</option>
                        <option value="+44">UK +44</option>
                        <option value="+33">FR +33</option>
                        <option value="+49">DE +49</option>
                        <option value="+39">IT +39</option>
                        <option value="+34">ES +34</option>
                        <option value="+81">JP +81</option>
                        <option value="+86">CN +86</option>
                        <option value="+7">RU +7</option>
                        <option value="+55">BR +55</option>
                        <option value="+61">AU +61</option>
                        <option value="+27">ZA +27</option>
                        <option value="+62">ID +62</option>
                        <option value="+82">KR +82</option>
                        <option value="+92">PK +92</option>
                        <option value="+20">EG +20</option>
                        <option value="+31">NL +31</option>
                        <option value="+32">BE +32</option>
                        <option value="+46">SE +46</option>
                        <option value="+47">NO +47</option>
                        <option value="+48">PL +48</option>
                        <option value="+30">GR +30</option>
                        <option value="+90">TR +90</option>
                        <option value="+52">MX +52</option>
                        <option value="+63">PH +63</option>
                        <option value="+66">TH +66</option>
                        <option value="+65">SG +65</option>
                        <option value="+60">MY +60</option>
                        <option value="+64">NZ +64</option>
                        <option value="+351">PT +351</option>
                        <option value="+353">IE +353</option>
                        <option value="+354">IS +354</option>
                        <option value="+358">FI +358</option>
                        <option value="+420">CZ +420</option>
                        <option value="+421">SK +421</option>
                        <option value="+43">AT +43</option>
                        <option value="+45">DK +45</option>
                        <option value="+41">CH +41</option>
                        <option value="+376">AD +376</option>
                        <option value="+387">BA +387</option>
                        <option value="+359">BG +359</option>
                        <option value="+375">BY +375</option>
                        <option value="+385">HR +385</option>
                        <option value="+357">CY +357</option>
                        <option value="+372">EE +372</option>
                        <option value="+358">FI +358</option>
                        <option value="+370">LT +370</option>
                        <option value="+371">LV +371</option>
                        <option value="+373">MD +373</option>
                        <option value="+382">ME +382</option>
                        <option value="+377">MC +377</option>
                        <option value="+389">MK +389</option>
                        <option value="+356">MT +356</option>
                        <option value="+423">LI +423</option>
                        <option value="+380">UA +380</option>
                        <option value="+387">BA +387</option>
                        <option value="+374">AM +374</option>
                        <option value="+994">AZ +994</option>
                        <option value="+996">KG +996</option>
                        <option value="+998">UZ +998</option>
                        <option value="+964">IQ +964</option>
                        <option value="+962">JO +962</option>
                        <option value="+961">LB +961</option>
                        <option value="+965">KW +965</option>
                        <option value="+966">SA +966</option>
                        <option value="+971">AE +971</option>
                        <option value="+973">BH +973</option>
                        <option value="+974">QA +974</option>
                        <option value="+968">OM +968</option>
                        <option value="+213">DZ +213</option>
                        <option value="+216">TN +216</option>
                        <option value="+212">MA +212</option>
                        <option value="+254">KE +254</option>
                        <option value="+256">UG +256</option>
                        <option value="+255">TZ +255</option>
                        <option value="+250">RW +250</option>
                        <option value="+249">SD +249</option>
                        <option value="+231">LR +231</option>
                        <option value="+233">GH +233</option>
                        <option value="+234">NG +234</option>
                        <option value="+225">CI +225</option>
                        <option value="+221">SN +221</option>
                        <option value="+220">GM +220</option>
                        <option value="+507">PA +507</option>
                        <option value="+502">GT +502</option>
                        <option value="+503">SV +503</option>
                        <option value="+505">NI +505</option>
                        <option value="+506">CR +506</option>
                        <option value="+509">HT +509</option>
                        <option value="+591">BO +591</option>
                        <option value="+595">PY +595</option>
                        <option value="+598">UY +598</option>

                        {/* Add more country codes as needed */}
                      </select>

                      {/* Phone Number Input */}
                      <input
                        type="text"
                        style={{ height: "2.5rem", flex: "1" }} // Ensure proper spacing
                        className="form-control border-1 phone-input"
                        name="phone"
                        value={formDatas.phone}
                        onChange={handleChanges}
                        placeholder="Contact"
                        maxLength="10"
                        pattern="[0-9]*"
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(/\D/, ""))
                        } // Prevent non-numeric input
                      />
                    </div>

                    {/* Error Message */}
                    {errors.phone && (
                      <p className="text-danger">{errors.phone}</p>
                    )}
                  </div>

                  <div className="col-lg-12 col-xl-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control border-1"
                        name="subject"
                        value={formDatas.subject}
                        onChange={handleChanges}
                        placeholder="Subject"
                        onKeyDown={(e) => {
                          if (
                            !/^[a-zA-Z\s]$/.test(e.key) &&
                            e.key !== "Backspace"
                          ) {
                            e.preventDefault(); // Prevent numbers and special characters
                          }
                        }}
                      />
                      {errors.subject && (
                        <p className="text-danger">{errors.subject}</p>
                      )}

                      <label>Subject</label>
                    </div>
                  </div>
                  <div className="col-lg-12 col-xl-6">
                    <div className="form-floating">
                      <select
                        name="service"
                        className="form-select border-1"
                        value={formDatas.service}
                        onChange={handleChanges}
                      >
                        <option>Select Our Service</option>
                        <option>KTIG Groups</option>
                        <option>Banking solution</option>
                        <option>Finance solution</option>
                        <option>IT solution</option>
                        <option>Non-IT solution</option>
                        <option>Sales & Ecommerce</option>
                        <option>Training & Coaching</option>
                        <option>Marketing</option>
                      </select>
                      {errors.service && (
                        <p className="text-danger">{errors.service}</p>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-12 col-xl-6">
                    <div className="form-floating">
                      <select
                        name="business"
                        className="form-select border-1"
                        value={formDatas.business}
                        onChange={handleChanges}
                      >
                        <option>Group of Business</option>
                        <option>Finance</option>
                        <option>Banking</option>
                        <option>Course Training</option>
                        <option>IT/ITES Services</option>
                        <option>Content Writing</option>
                        <option>Web design & Development</option>
                      </select>
                      {errors.business && (
                        <p className="text-danger">{errors.business}</p>
                      )}
                    </div>
                  </div>
                </div>
                <div class="col-lg-12 col-xl-12 d-flex align-items-center justify-content-center justify-content-lg-end ">
                  <div class="form_right btn-md-square rounded-circle">
                    <i class="fa fa-phone-alt fa-2x"></i>
                  </div>
                </div>
              </form>
              <div className="btn-container cantact_cta col-12">
                <button
                  type="button"
                  className="btn-grad btn w-100 py-3"
                  onClick={handleSubmits}
                >
                  Submit Your Subject
                </button>
              </div>

              {showAlert && (
                <div
                  className="showalert"
                  style={{
                    position: "fixed",
                    top: "10vh", // More flexible positioning
                    left: "50%",
                    transform: "translateX(-50%)",
                    backgroundColor: "#ffff",
                    color: "#000",
                    padding: "15px 30px",
                    borderRadius: "8px",
                    fontSize: "16px",
                    boxShadow: "0 5px 15px rgba(0, 0, 0, 0.1)",
                    zIndex: 1000,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    width: "90%", // Adjust width for mobile
                    maxWidth: "380px", // Restrict width on larger screens
                    textAlign: "center",
                    opacity: 1,
                    transition: "all 0.3s ease",
                  }}
                >
                  <h2
                    style={{
                      marginTop: "20px",
                      fontSize: "20px",
                      fontWeight: "500",
                    }}
                  >
                    Success!
                  </h2>
                  <h3 style={{ fontSize: "16px", fontWeight: "400" }}>
                    Your Form is Successfully Submitted.
                  </h3>
                  <div style={{ marginTop: "20px" }}>
                    <button
                      onClick={() => setShowAlert(false)}
                      style={{
                        fontSize: "14px",
                        padding: "6px 12px",
                        margin: "0 10px",
                        backgroundColor: "#071C40",
                        color: "#fff",
                        borderRadius: "6px",
                        border: "none",
                        cursor: "pointer",
                      }}
                    >
                      Close
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <Footer />

      <a
        href="#"
        className="btn btn-secondary btn-lg-square rounded-circle back-to-top"
      >
        <i className="fa fa-arrow-up"></i>
      </a>
    </div>
  );
}

export default Mainpage;
